import { sendGet, sendPut } from './axios';

// eslint-disable-next-line import/prefer-default-export
export const loadProfile = () => sendGet('/cms/auth/profile');
export const updateProfile = (payload: any) => sendPut('/cms/auth/profile', payload);
export const changePassword = (payload: any) => sendPut('/cms/auth/change-password', payload);
